import { workSessionService } from '../services/workSessionService';
import { breakTrackingService } from '../services/breakTrackingService';
import { createUseWorkSession } from './useWorkSessionBase';
/**
 * Web work session hook
 * Uses web API client with cookie-based authentication
 */
export const useWorkSession = createUseWorkSession(workSessionService, breakTrackingService);
export default useWorkSession;
